<template>
  <div v-if="!context.as_select" class="mb-4">
    <ul class="grid gap-y-[6px]">
      <li v-for="(item, i) in options">
        <label
          class="flex items-start relative bg-black-50 dark:bg-white/10 rounded px-4 py-3"
          :class="[
            {
              'opacity-50':
                (inputType === 'checkbox' && !model.includes(i) && passed) ||
                (inputType === 'radio' && passed),
            },
            { 'cursor-pointer': !passed },
          ]"
        >
          <div
            class="w-6 h-6 flex border-2 border-primary bg-white dark:bg-white/10 mr-3 flex-none z-10"
            :class="[
              inputType === 'checkbox' ? 'rounded-md' : 'rounded-full',
              item.caption ? 'mt-1' : '',
            ]"
          >
            <IconCheck
              v-if="inputType === 'checkbox' && model.includes(item.id)"
              class="size-4 m-auto stroke-[6px]"
              :class="model.includes(item.id) ? 'text-primary' : 'text-white'"
            />
            <div
              class="w-3 h-3 m-auto rounded-full bg-primary"
              v-if="inputType === 'radio' && model === item.id"
            />
          </div>
          <div class="flex flex-col">
            <div class="font-medium pr-12" v-text="item.title" />
            <div
              v-if="item.caption"
              class="pr-12 dark:text-white/60 text-black/60 text-sm"
              v-text="item.caption"
            />
          </div>
          <input
            v-model="model"
            class="absolute opacity-0"
            :disabled="passed"
            :type="inputType"
            :value="item.id"
          />
        </label>
      </li>
    </ul>
    <div v-if="false" class="flex flex-col items-start">
      <div class="my-4 w-full">
        <textarea
          v-model="other"
          class="w-full p-3 rounded-md border-2 outline-none bg-white border-primary-500"
          rows="4"
          placeholder="Введите свой ответ"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <FormKit
      type="qselect"
      :placeholder="context.placeholder"
      :options="context.options"
      label-by="title"
      track-by="id"
      :multiple="context.multiple"
      v-model="model"
      :classes="{ outer: '!mb-0' }"
    />
  </div>
</template>

<script setup>
import { findIndex, isNumber, shuffle } from 'lodash-es'
import { computed, onMounted, ref } from 'vue'

import { IconCheck } from '@tabler/icons-vue'

const props = defineProps({
  context: {
    type: Object,
    default: {},
  },
  modelValue: {
    type: [Array, Object, String, Number],
  },
  passed: {
    type: Boolean,
  },
  current: {
    type: Boolean,
  },
  accept: {
    default: () => null,
  },
})

const inputType = ref(props.context.multiple ? 'checkbox' : 'radio')

const options = computed(() => {
  return props.context.shuffle
    ? shuffle(props.context.options)
    : props.context.options
})

const other = ref('')
const emits = defineEmits(['passed', 'update:model-value'])

const model = computed({
  get: () => {
    return props.modelValue ?? []
  },
  set: (val) => {
    emits('update:model-value', val)
  },
})
</script>
